<template>
  <div class="show-accounts">
    <div class="detail" v-for="(account, detailsIndex) in accountDetails"
      :key="detailsIndex">
      <b class="title" v-if="account.title">
        {{account.title}}
      </b>

      <strong v-if="account.value">{{account.value}}</strong>
      <div class="value-row" v-else>
        <div v-for="(data, dataIndex) in account.arrayVal"
          :key="dataIndex"
          class="row"
        >
          <div v-for="(item, itemIndex) in data"
            :key="itemIndex"
            class="item"
          >
            <b>{{item.title}}</b>
            <strong :class="{'thin': !item.copy}">{{item.value}}</strong>
            <i v-if="item.copy" class="fa fa-copy"
              @click="copyAccDetails(item.value, item.title)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { copyText } from '@/utils/helpers'

export default {
  name: 'ShowAccounts',
  props: {
    accountDetails: Array
  },
  methods: {
    copyText,
    copyAccDetails (data, type) {
      this.copyText(data, {text: `Copied ${type}: '${data}'`})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/mixins.scss';

  .detail {
    display: flex;

    &:not(:last-child) {
      margin-bottom: 20px;
    }

    b.title {
      min-width: 120px;
      text-align: left;
      @include normal-text($grey-2, 14px, normal);
    }

    .value-row {
      display: grid;
      grid-gap: 15px;

      .row {
        display: flex;
        flex: 1;
        flex-direction: column;
        text-align: left;

        .item {
          display: flex;
          align-items: center;

          b {
            @include normal-text($grey-2, 14px, normal);
            min-width: 60px;
            text-align: left;
          }

          &:not(:last-child) {
            margin-bottom: 5px;
          }

          .thin {
            font-weight: normal;
          }
        }

        &:not(:last-child) {
          margin-bottom: 5px;
        }

        .fa {
          margin-left: 10px;
          color: rgba(101, 109, 113, .5);
          cursor: pointer;
        }
      }
    }
  }

  .desktop {
    .detail {
      .value-row {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-wrap: wrap;

        .data {
          width: 50%;
        }
      }
    }
  }

  .mobile, .tablet {
    .value-row {
      .data:not(:last-child) {
        display: block;
        margin-bottom: 15px;
      }
    }
  }
</style>
